DocumentValidator.$inject = ['validator'];

export default function DocumentValidator(validator) {
    const instance = new validator();
    return instance;
}
